import styled from 'styled-components';

export const Container = styled.div`
  img {
    display: block;
    max-width: 100%;
    width: 100%;
    cursor: pointer;
    object-fit: cover;
  }
`;
